<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <div class="notice-page">
      <div class="row-center-noGutter fade-in">
        <preamble-block
          class="col-12_md-8_lg-6"
          :prefix="prefix"
          :title="title"
          :preamble="preamble"
          align="left"
        />
      </div>
      <BylineShareComponent
        :author="author"
        :authordate="authorDate"
        :title="seoTitle || title"
        :description="seoDescription"
        size="narrow"
      />
      <div class="row-center-noGutter fade-in">
        <div class="col-12_md-8_lg-6">
          <div
            v-if="image || imageUrl"
            class="notice-page__media-wrapper"
          >
            <epi-picture
              v-if="!imageUrl && image"
              :use-picture="true"
              :auto-aspect-ratio="false"
              :image="(!imageUrl && image) && image"
              edit="Image"
            />
            <img
              v-else
              :src="imageUrl"
              alt=""
            >
          </div>
        </div>
      </div>
      <div class="row-center-noGutter fade-in">
        <div class="col-12_md-10_lg-8">
          <wysiwyg
            v-if="content || isEditable"
            v-edit="'Content'"
            class="wysiwyg--contentarea"
            :content="content"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PreambleBlock from '@/vue/blocks/PreambleBlock/preambleBlock'
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import BylineShareComponent from '@/vue/components/bylineShareComponent/bylineShareComponent'

import '#/Social/Twitter'
import '#/Social/Facebook'
import '#/Communication/Link'

export default {
  name: 'NoticePage',
  components: {
    PreambleBlock,
    BylineShareComponent
  },
  mixins: [pageWithNavigation],
  props: {
    prefix: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    seoDescription: {
      type: String,
      default: ''
    },
    seoTitle: {
      type: String,
      default: ''
    },
    preamble: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      default: () => []
    },
    breadcrumbs: {
      type: Array,
      default () {
        return []
      }
    },
    author: {
      type: String,
      default: ''
    },
    authorDate: {
      type: String,
      default: ''
    },
    displayImagesInNavigationBlocks: {
      type: Boolean,
      default: false
    },
    image: {
      type: Object,
      default: null
    },
    imageUrl: {
      type: String,
      default: ''
    },
    contentAreaTitle: {
      type: String,
      default: ''
    },
    contentArea: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      show: true
    }
  },
  computed: {
    aspectRatioMode () {
      return this.$root.currentSizeLte('sm')
    }
  },

}
</script>

<style lang="scss">
.notice-page {
  margin: 0 -1rem;
  padding: 2rem 0 3.5rem 0;
  border-radius: 0.25rem;
  background-color: $color-white;

  @include media-breakpoint-up(md) {
    margin: 0;
    padding: 3rem 0 4.5rem 0;
  }

  @include media-breakpoint-up(lg) {
    padding: 3.5rem 0 5.5rem 0;
  }

  @include media-breakpoint-up(xl) {
    padding: 4rem 0 6.5rem 0;
  }

  &__media-wrapper {
    border: 1px solid $color-grey-special;
    border-radius: 0.25rem;
    margin: 0 1.5rem 0 1.5rem;
    margin-bottom: 2rem;
    padding: 1rem 3rem;
    text-align: center;

    @include media-breakpoint-up(md) {
      padding: 2.5rem 5.5rem;
      margin: 0;
      margin-bottom: 2.5rem;
    }

    @include media-breakpoint-up(lg) {
      padding: 2.5rem 7rem;
    }

    @include media-breakpoint-up(xl) {
      padding: 2.5rem 8.75rem;
      margin-bottom: 3rem;
    }
  }

  &__content {
    margin-bottom: 2.5rem;

    @include font(text, 3, "normal");
  }

  // this is special for cision as we are getting inline styling from them for some reason they cannot remove, so an important is set to match our styling
  .cision-wrapper {
    p,
    span {
      font-family: 'ICA Text', Arial, Helvetica, sans-serif !important;
      font-size: 1rem !important;
    }
  }

  .epi-background-container,
  .empty-image-placeholder {
    border-radius: 0.25rem;
    padding-bottom: 56.25%;
  }

  .empty-image-placeholder {
    height: auto;
  }

  &__form-wrapper {
    padding: 0 1.5rem;

    @include media-breakpoint-up(md) {
      padding: 0 6.4375rem;
    }
  }
}

.notice-page-accordion {
  margin-top: 2rem;

  @include media-breakpoint-up(md) {
    margin-top: 3rem;
  }

  @include media-breakpoint-up(lg) {
    margin-top: 3.5rem;
  }

  @include media-breakpoint-up(xl) {
    margin-top: 4rem;
  }
}

</style>
